import { aktivasyon } from "./Rsa";
import { store } from "redux/store";

export const createRSAKey = (PblExponet: string, PblModulus: string) => {
  aktivasyon.CreateRSAKey(PblExponet, PblModulus);
};

export const RSAEncrypt = (text: string): string => {
  if (aktivasyon.key) {
    return aktivasyon.RSAEncrypt(text);
  } else {
    const reduxStore = store.getState();
    const PblExponet = reduxStore.WebSecurity?.webSec?.PblExponet;
    const PblModulus = reduxStore.WebSecurity?.webSec?.PblModulus;

    if (PblExponet && PblModulus) {
      createRSAKey(PblExponet, PblModulus);
    }
  }

  return "";
};
